import { SID as SID_DOMAIN } from "@securitize/domain";

export const KybSectionStatuses = {
  EMPTY: "empty",
  IN_PROGRESS: "in-progress",
  COMPLETED: "completed",
  UPDATES_REQUIRED: "updates-required",
} as const;

export type KybSectionStatus =
  (typeof KybSectionStatuses)[keyof typeof KybSectionStatuses];

export interface EntityInformationSectionDto {
  status: KybSectionStatus;
  missingFields?: string[];
}

export interface DocumentsSectionDto {
  status: KybSectionStatus;
  missingTypes?: string[];
  missingAmount?: number;
}

export interface KeyPartiesSectionDto {
  status: KybSectionStatus;
  created?: number;
}

export interface KybDto {
  status: KybSectionStatus;
  entityInformation: EntityInformationSectionDto;
  documents: DocumentsSectionDto;
  keyParties: KeyPartiesSectionDto;
}

export type GroupedLegalSigner = {
  legalSignerId: string;
  legalSignerName: string;
  updateItems: string[];
};

export interface EntityInformationFieldCommentDto {
  fieldKey: string;
  comment: string;
}

export interface DocumentCommentDto {
  documentId: string;
  comment: string;
}

export interface KeyPartyCommentDto {
  legalSignerId: string;
  comment: string;
}

export interface RequestedUpdatesGrouped {
  additionalDocumentation?: string[];
  legalSignerMissingInfo?: GroupedLegalSigner[];
  comments?: string;
  additionalComments?: string;
  entityInformationComments?: EntityInformationFieldCommentDto[];
  documentComments?: DocumentCommentDto[];
  keyPartiesGeneralComment?: string;
  keyPartyComments?: KeyPartyCommentDto[];
  /**
   * ISO timestamp identifying this round of requested updates. Used to bind
   * client-side flag resolution (see updatesRequiredResolution.ts) to the
   * specific round it was resolved in, so a later round re-flagging the same
   * field/key party isn't silently suppressed by a stale resolution.
   */
  requestedAt?: string;
}

export interface OnboardingOriginDto {
  issuerName?: string;
  issuerReturnUrl?: string;
}

export interface OnboardingStatusDto {
  verificationStatus: SID_DOMAIN.VerificationStatus;
  investorType: SID_DOMAIN.InvestorType;
  kyb: KybDto;
  editableProfileEnabled?: boolean;
  requestedUpdatesGrouped?: RequestedUpdatesGrouped;
  onboardingOrigin?: OnboardingOriginDto;
}
